import React, { useState } from 'react';
import HistoryClinicIcon from '../../assets/img/historial-prestaciones.svg'
import { useStateAuthValue } from '../../context/Auth/AuthState';
import { PatientSearch } from '../../services/patientService';
import LoadingSpinner from '../../components/LoadingSpinner';
import SearchBox from './SearchBox';
import SearchResult from './SerchedResult';

const HistoryClinic = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ userData ] = useStateAuthValue();

    const getData = async (params) => {
        setLoading(true);
        await PatientSearch(userData.userToken, params)
        .then((response) => {
           const resultado = limpiarYAgruparPacientes(response.data);
            setResults(resultado);
         })
        .finally(() => setLoading(false));
     };


    const limpiarYAgruparPacientes = (lista) => {
        return Object.values(
            lista.reduce((acc, item) => {
                // Tomamos id_number o idNumber por si viene en cualquiera de los dos formatos
                const key = item.id_number || item.idNumber;

                if (!acc[key]) {
                    // Si es el primer registro para este id_number, lo guardamos
                    acc[key] = { ...item };
                } else {
                    // Si el id_number ya existe, concatenamos únicamente los correos de ESTE paciente
                    if (item.userLogin && !acc[key].userLogin.includes(item.userLogin)) {
                        acc[key].userLogin = acc[key].userLogin
                            ? `${acc[key].userLogin},${item.userLogin}`
                            : item.userLogin;
                    }

                    // Mantenemos el id (o clinicHistoryId) más alto
                    const currentId = acc[key].id ?? acc[key].clinicHistoryId;
                    const newItemId = item.id ?? item.clinicHistoryId;

                    if (newItemId !== null && newItemId !== undefined) {
                        if (currentId === null || currentId === undefined || newItemId > currentId) {
                            if ('id' in acc[key]) acc[key].id = newItemId;
                            if ('clinicHistoryId' in acc[key]) acc[key].clinicHistoryId = newItemId;
                        }
                    }
                }

                return acc;
            }, {})
        );
    };
    const handelSearchClick = (params) => {
        setResults([]);
        getData(params);
    };
    return (
        <div className="history-clinic">
            <div className="header">
                <img className="image" src={HistoryClinicIcon} alt="Historia Clinica" />
                <h2>Historia Clinica</h2>
            </div>
            <div className="column">
            <SearchBox onSearch={handelSearchClick}/>
            {loading && <LoadingSpinner />}
            <SearchResult results={results}/>
            </div>
        </div>
    );
};

export default HistoryClinic;
